// Système par défaut pour les appels API APPRO
export const DEFAULT_SYSTEME = 'APPRO';

// Provenance envoyée aux endpoints de compte (PAD est en mode Appro seul)
export const PROVENANCE_APPRO = 'Appro';

export const ApiNamespaces = {
    compte: globalThis.VITE_GATEWAY_NEC_API_ROOT ?? '',
};
